<script>
import { mapActions, mapGetters } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Users'
    },

    extends: TableView,

    data() {
        const { role = null } = this.$route.query;

        return {
            pageTitle: 'Users',
            activeTab: {
                value: role
            }
        };
    },

    computed: {
        ...mapGetters({
            isHeadAdmin: 'auth/isHeadAdmin',
            ALL_ROLES: 'roles/ALL_ROLES'
        }),

        tabsElements() {
            return [{ value: null, text: 'All' }, ...this.ALL_ROLES];
        },

        options() {
            const options = {};

            if (this.activeTab.value) {
                options.linkSuffix = `&role=${this.activeTab.value}`;
            }

            return options;
        },

        labels() {
            return [
                { value: 'firstName', width: '200px' },
                {
                    value: 'lastName',
                    width: '200px'
                },
                { value: 'email', width: '300px' },
                {
                    text: 'Role',
                    value: 'roles',
                    filter: val => val.map(role => role.name).join(', '),
                    width: '200px',
                    sortable: false,
                    filterable: false
                },
                { value: 'tz', width: '180px' },
                {
                    value: 'phone',
                    width: '200px'
                },
                {
                    text: 'Hugs',
                    value: 'hugs',
                    width: '200px',
                    sortable: false,
                    filterable: false,
                    filter: v => v.map(hug => hug.number).join(', ')
                },
                {
                    value: 'campuses',
                    width: '150px',
                    sortable: false,
                    filterable: false,
                    filter: v => v.map(campus => campus.name).join(', ')
                },
                {
                    value: 'createdAt',
                    text: 'Registration date',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                }
            ];
        },

        additionalFetchData() {
            return {
                role: this.activeTab.value
            };
        }
    },

    watch: {
        activeTab() {
            this.pagination.currentPage = 1;
            this.pagination.sortBy = 'createdAt';
            this.fetchItems();
        }
    },

    methods: {
        ...mapActions({
            getItems: 'users/index',
            deleteItem: 'users/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/users/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/users/add');
        }
    }
};
</script>
